import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { css } from 'lit'

export const stripeStyle = css`
  cse-paper {
    --cse-paper-border-width: ${csBorder.width};
  }
`
